import { FilterModalTypes } from '../../../../../../components/FilterModal';
import { TableHeadItemRecurse } from '../../../../../../components/TableHead';

export const tableHead: TableHeadItemRecurse[] = [
  { title: 'Cliente', flex: 1.8 },
  { title: 'Ativo' },
  { title: 'Data da posição' },
  { title: 'Data de vencimento' },
  { title: 'Quantidade' },
  { title: 'Valor bruto' },
];

export const getDirectTreasuryFilters = (): FilterModalTypes.FilterType[] => [
  {
    type: 'date',
    fieldName: 'positionDate',
    title: 'Data posição',
    placeholder: 'Selecione a data da posição',
  },
  {
    type: 'date',
    fieldName: 'maturityDate',
    title: 'Data vencimento',
    placeholder: 'Selecione a data de vencimento',
  },
  {
    type: 'range',
    fieldName: 'quantity',
    labelType: 'number',
    title: 'Quantidade total',
    min: 0,
    max: 1000000000,
  },
  {
    type: 'range',
    fieldName: 'grossValue',
    labelType: 'money',
    title: 'Valor bruto',
    min: 0,
    max: 1000000000,
  },
];
